module.exports = __webpack_public_path__ + "img/UberEats1.8df2b0e6.png";